import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { CapaQuotationPartnerEquipment } from '@generated/graphql';
import { getFileUrl } from '@utils/urls';
import { CustomizedTypography } from '@components/Customized';
import EquipmentDetailView from './DetailView/EquipmentDetailView';

interface CompanyEquipmentEntryProps {
  equipment: CapaQuotationPartnerEquipment;
}

const CompanyEquipmentEntry: React.FunctionComponent<CompanyEquipmentEntryProps> = ({
  equipment
}) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const { documentEntryContainer, documentEntryData } = useStyles();
  const { file, quantity, equipmentName, description } = equipment;

  return (
    <>
      <EquipmentDetailView
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        equipment={equipment}
      />
      <div
        className={documentEntryContainer}
        onClick={() => {
          setOpenDialog(true);
        }}
      >
        <div className={documentEntryData}>
          <div className="certificate-image">
            <img
              loading="lazy"
              src={getFileUrl(file?.fileId ?? '')}
              alt={file?.fileName ?? ''}
            />
          </div>
          <div>
            <CustomizedTypography
              className="technicalName ellipsis"
              variant="body1"
              fontWeight="500"
              color="textPrimary"
              gutterBottoms={4}
            >
              {equipmentName}
            </CustomizedTypography>
            <CustomizedTypography
              variant="subtitle2"
              color="textSecondary"
              className="ellipsis"
              gutterBottoms={2}
            >
              {quantity && `${quantity.toLocaleString('kr')}대 보유 중`}
            </CustomizedTypography>
            <CustomizedTypography
              variant="subtitle2"
              color="textSecondary"
              className="ellipsis"
            >
              {description}
            </CustomizedTypography>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyEquipmentEntry;

const useStyles = makeStyles((theme) => ({
  documentEntryContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: '80px',
    gap: '16px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  documentEntryData: {
    width: '100%',
    display: 'flex',
    gap: '16px',
    borderRadius: '12px',
    overflow: 'hidden',
    '&:hover': {
      '& .technicalName': {
        textDecoration: 'underline'
      }
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    '& .certificate-image': {
      minWidth: '64px',
      maxWidth: '64px',
      height: '80px',
      borderRadius: '8px',
      overflow: 'hidden'
    },
    '& .ellipsis': {
      wordBreak: 'break-all',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': 1,
      '-webkit-box-orient': 'vertical'
    }
  }
}));
